<template>
  <svg
    width="1"
    height="14"
    viewBox="0 0 1 14"
  >
    <path d="M0.5 0C0.776142 0 1 0.223858 1 0.5V13.5C1 13.7761 0.776142 14 0.5 14C0.223858 14 0 13.7761 0 13.5V0.5C0 0.223858 0.223858 0 0.5 0Z" />
  </svg>
</template>
